var map = {
	"./Npk.png": 2599,
	"./Organic.png": 9709,
	"./Pesticide.png": 3230,
	"./Weather-Night.png": 8971,
	"./Weather-Rain.png": 8215,
	"./Weather-Sun-Cloud.png": 2471,
	"./Weather-Sun-Rain.png": 884,
	"./Weather-Thunder.png": 9423,
	"./apples.png": 2147,
	"./bud-development.png": 3687,
	"./cabbage.png": 295,
	"./classCarousel-1.png": 6414,
	"./classCarousel-2.png": 2165,
	"./contact-1.png": 540,
	"./cropYield-1.png": 2405,
	"./cropYield-2.png": 9982,
	"./cucumber.mp4": 1785,
	"./descImg-1.png": 288,
	"./descImg-2.png": 1579,
	"./descImg-3.png": 450,
	"./descImg-4.png": 4701,
	"./descImg-5.png": 1668,
	"./descImg-6.png": 6159,
	"./durian.png": 6671,
	"./flowering.png": 4001,
	"./font/Baloo-Regular-webfont.woff": 7402,
	"./forecast.png": 5151,
	"./forecastIcon-1.svg": 7636,
	"./forecastIcon-2.svg": 5495,
	"./forecastIcon-3.svg": 8374,
	"./forum-prof1.png": 4032,
	"./forum-prof2.png": 3883,
	"./forum-prof3.png": 6402,
	"./fruit-formation.png": 9430,
	"./germination.png": 4943,
	"./heatmap.png": 8054,
	"./heroPlant-1.png": 8751,
	"./heroPlant-2.png": 4260,
	"./leaf-tnc.jpg": 8446,
	"./loading-circle.svg": 8479,
	"./loginImg-1.png": 7530,
	"./loginImg-2.png": 7697,
	"./logo.png": 3153,
	"./mango.png": 2032,
	"./mapImage-1.png": 479,
	"./marketCarousel-1.png": 7504,
	"./marketCarousel-2.png": 1323,
	"./marketCarousel-3.png": 818,
	"./plant-simulation1.png": 2008,
	"./plantImage-1.png": 2440,
	"./plantImage-2.png": 6931,
	"./register-farmer.png": 3551,
	"./register-plantppl.png": 7887,
	"./register-success.png": 8177,
	"./ripening.png": 1572,
	"./seedling.png": 9703,
	"./septoria.png": 6541,
	"./serai.png": 3554,
	"./services-dashboard.png": 9531,
	"./services-dashboard2.png": 1377,
	"./services-forecast.jpg": 7932,
	"./services-spacemap.png": 6103,
	"./soilMonitor-1.jpg": 8085,
	"./tomato.mp4": 7583,
	"./tomato.png": 3462,
	"./tomato2.mp4": 1333,
	"./vegetative-growth.png": 5166,
	"./weather-sun.png": 7179,
	"./weatherIcon-1.svg": 7343,
	"./weatherIcon-10.svg": 5645,
	"./weatherIcon-2.svg": 5020,
	"./weatherIcon-3.svg": 3565,
	"./weatherIcon-4.svg": 3282,
	"./weatherIcon-5.svg": 6595,
	"./weatherIcon-6.svg": 7200,
	"./weatherIcon-7.svg": 8321,
	"./weatherIcon-8.svg": 902,
	"./weatherIcon-9.svg": 7767,
	"./weather_rectangle.svg": 9188
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;